import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { hasRestrictedRole, isInsuracePortalUser } from 'globalutils/fmUtils';
import { ROLES } from 'globalconfig/constants/keys';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ provider }) => {
  return {
    setSelectedIndexfn: {
      [SERVICE_PROVIDERS.CLUTCH]: () => ({ addValue: 125, mulVal: 45 }),
      default: () => false,
    },
    rtfmUser: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.FLMANAGER]),
      default: () => false,
    },
    topAction_import: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => !isInsuracePortalUser(),
      default: () => false,
    },
    topAction_impExpWrapper: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    topAction_iconWrapper: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => !hasRestrictedRole([ROLES.VIEW_ONLY_FM]),
    },
    driverStatusList_mapWrapper: {
      [SERVICE_PROVIDERS.RADIUS]: () => false,
      [SERVICE_PROVIDERS.NAUTO]: () => false,
      default: () => true,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
